var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconChangeordersOverview(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 28,
    viewBox: "0 0 26 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1571_4646)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8801 1.63H0.350098V12.16H10.8801V1.63Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1001 16.37H18.2601V18.5H15.1001V16.37Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3101 16.37H22.4901V18.5H19.3101V16.37Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 16.37H25.6002V19.5H23.4902V16.37Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1001 23.75H17.2001V26.9H15.1001V23.75Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2603 24.8H21.4203V26.9H18.2603V24.8Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4902 24.8H25.6502V26.9H22.4902V24.8Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1001 19.5H17.2001V22.66H15.1001V19.5Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4902 20.59H25.6002V23.75H23.4902V20.59Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.77999 22.56V19.83L13.4 23.5L9.77999 27.17V24.4C8.81929 24.4127 7.86627 24.2275 6.98026 23.8558C6.09425 23.4842 5.29422 22.9342 4.62999 22.24C3.94066 21.5752 3.39507 20.776 3.02698 19.8919C2.65888 19.0078 2.47612 18.0576 2.48999 17.1C2.47849 15.7165 2.88259 14.3613 3.64999 13.21L4.94999 14.5C4.52009 15.2841 4.29966 16.1659 4.30999 17.06C4.31529 18.5064 4.89425 19.8915 5.91978 20.9114C6.94532 21.9313 8.33364 22.5027 9.77999 22.5V22.56Z",
    fill: "#143366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1502 3.60002C17.1109 3.58735 18.064 3.77258 18.95 4.14419C19.836 4.5158 20.636 5.06582 21.3002 5.76002C22.4818 6.91322 23.2272 8.44026 23.4095 10.0812C23.5918 11.7222 23.1998 13.3756 22.3002 14.76L20.9702 13.5C21.4088 12.7189 21.6331 11.8357 21.6202 10.94C21.6301 10.2207 21.4923 9.50705 21.2154 8.84312C20.9384 8.1792 20.5283 7.57913 20.0102 7.08002C19.5104 6.56499 18.9095 6.15879 18.2452 5.8869C17.581 5.61501 16.8678 5.4833 16.1502 5.50002V8.17002L12.4902 4.50002L16.1202 0.830017V3.60002H16.1502Z",
    fill: "#143366"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1571_4646"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3,
    height: 26.34,
    fill: "white",
    transform: "translate(0.350098 0.830017)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChangeordersOverview);
export default __webpack_public_path__ + "static/media/icon-changeorders-overview.0e4eb944e2f61e2fa75b653b10fdf2a8.svg";
export { ForwardRef as ReactComponent };